import { cn } from '@core/utils';

interface CenteredDetailTemplateProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
  footerClassName?: string;
}

/**
 * cta footer를 옵셔널하게 추가할 수 있는 단순한 형태의 상세 페이지
 */
export const CenteredDetailTemplate = ({
  children,
  footer,
  className,
  fullWidth = false,
  footerClassName,
}: CenteredDetailTemplateProps) => {
  return (
    <>
      <article
        className={cn(
          'mx-auto flex w-full flex-col',
          !fullWidth && 'max-w-[750px]',
          footer && 'pb-80',
          className,
        )}
      >
        {children}
      </article>
      {footer ? (
        <footer
          className={cn(
            'fixed inset-x-0 bottom-0 z-[1] bg-Gray-white',
            footerClassName,
          )}
        >
          <div className="mx-auto flex w-full max-w-[750px] gap-8 px-20 py-12">
            {footer}
          </div>
        </footer>
      ) : null}
    </>
  );
};
